import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Track SPA page views in Google Analytics (only if GA loaded after consent)
    if (window._gaLoaded && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: pathname,
        page_title: document.title
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
